import { useMutation, useQueryClient } from "@tanstack/react-query";

import createPrivateAdminPanelInstance from "../../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../../api/ApiRoutes";
import { CASINO_CONFIGURATION_GAMES_SCOPE_QUERY_KEY } from "./casinoConfigurationGamesQueryKeys";

export type CasinoConfigurationBulkToggleScope = {
  provider: string;
  sub?: string;
  game_id?: string;
};

export type CasinoConfigurationBulkToggleVariables = {
  is_active: boolean;
  scope: CasinoConfigurationBulkToggleScope;
};

export function useCasinoConfigurationBulkToggleGames() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (variables: CasinoConfigurationBulkToggleVariables) => {
      const token = JSON.parse(localStorage.getItem("token") ?? "null");
      const instance = createPrivateAdminPanelInstance(token?.AccessToken);
      const { data: responseBody } = await instance.post(
        API_ROUTES.BULK_ACTIVE_GAMES,
        { is_active: variables.is_active, scope: variables.scope },
      );
      if (responseBody?.success === false) {
        throw new Error(responseBody?.message || "Bulk toggle rejected");
      }
      return responseBody;
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: CASINO_CONFIGURATION_GAMES_SCOPE_QUERY_KEY,
      });
    },
  });
}
